export default __webpack_public_path__ + "static/media/live-icon-active.f9790c9d.webp";